import { useNavigate, useParams } from "@tanstack/react-router";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { Loader, toast } from "@/components/kit";
import { ProductFormPageHeader } from "@/modules/products/presentation/ui/ProductFormPageHeader";
import { formatDateForInput } from "@/shared/lib/date-time";
import { useGoodsReceiptQuery, useUpdateGoodsReceipt } from "../api/queries";
import { GoodsReceiptForm } from "../ui/GoodsReceiptForm";

export function GoodsReceiptEditPage() {
  const nav = useNavigate();
  const { id } = useParams({ from: "/app/inventory/receive/$id/edit" });
  const receipt = useGoodsReceiptQuery(id);
  const update = useUpdateGoodsReceipt(id);

  const data = receipt.data;

  if (receipt.isLoading) {
    return (
      <>
        <Header />
        <Main>
          <div className="flex justify-center py-16">
            <Loader />
          </div>
        </Main>
      </>
    );
  }

  if (data?.status !== "draft") {
    return (
      <>
        <Header />
        <Main>
          <div className="brand-card p-8 text-center text-muted-foreground text-sm">
            ແກ້ໄຂໄດ້ສະເພາະໃບຮັບເຂົ້າສະຖານະຮ່າງ
          </div>
        </Main>
      </>
    );
  }

  return (
    <>
      <Header />
      <Main>
        <ProductFormPageHeader
          title={`ແກ້ໄຂ ${data.receiptNumber}`}
          subtitle="ປັບລາຍການ / ຕົ້ນທຸນ / ຄ່າຂົນສົ່ງ"
          onBack={() =>
            nav({ to: "/app/inventory/receive/$id", params: { id } })
          }
        />
        <GoodsReceiptForm
          submitting={update.isPending}
          submitLabel="ບັນທຶກການແກ້ໄຂ"
          defaultValues={{
            receivedAt: formatDateForInput(data.receivedAt),
            carrier: data.carrier ?? "hung_arun",
            carrierNote: data.carrierNote ?? "",
            trackingNumber: data.trackingNumber ?? "",
            shippingFeeTotal: Number(data.shippingFeeTotal),
            otherFeesTotal: Number(data.otherFeesTotal),
            shippingAllocationMethod: data.shippingAllocationMethod,
            note: data.note ?? "",
            lines: data.lines.map((l) => ({
              variantId: l.variantId,
              productName: l.productName,
              variantName: l.variantName,
              imageKey: null,
              quantity: l.quantity,
              unitPurchaseCost: Number(l.unitPurchaseCost),
              shippingAllocated: Number(l.shippingAllocated),
              stockUnitLabel: l.stockUnitLabel,
              receiveUnitLabel: l.receiveUnitLabel,
              receiveConversionFactor: Number(l.conversionFactor),
            })),
          }}
          onSubmit={async (payload) => {
            try {
              await update.mutateAsync(payload);
              toast.success("ບັນທຶກການແກ້ໄຂສຳເລັດ");
              nav({ to: "/app/inventory/receive/$id", params: { id } });
            } catch {
              toast.error("ບັນທຶກລົ້ມເຫຼວ");
            }
          }}
        />
      </Main>
    </>
  );
}
